import { Data, Layout } from "plotly.js";
import {
  getDefaultPlotData,
  getLegendConfig,
  getPlotLayout,
} from "../plotConfig";

import { stbColors } from "Components/Themes/Storebrand/storebrandColors";
import { formatToLocaleString } from "Formatting/formatNumber";
import { WindowSize } from "Utils/screenSizeUtils";
import { AdvicePlotDeathProps } from "./AdvicePlotDeath";

export const getLayout = (
  props: AdvicePlotDeathProps,
  mobileVariant: boolean,
  windowSize: WindowSize,
): Partial<Layout> => {
  const { payout, debt, range } = props;

  return {
    ...getPlotLayout(
      {
        tickvals: [payout, debt],
        ticktext: ["", ""],
        range,
      },
      windowSize,
      mobileVariant ? { height: 200, marginR: 0 } : { height: 200 },
    ),
    ...(mobileVariant && getLegendConfig(-0.65)),
  };
};

export const getData = (props: AdvicePlotDeathProps): Data[] => {
  const { payout, debt, valueType, advicePlot, lang } = props;

  return [
    {
      ...getDefaultPlotData(),
      x: advicePlot.xValues[lang],
      y: [debt, 0],
      text: [`${formatToLocaleString(debt)} ${valueType}`, ""],
      marker: { color: stbColors.charts.blue70 },
      showlegend: false,
    },
    {
      ...getDefaultPlotData(),
      x: advicePlot.xValues[lang],
      y: [0, payout],
      text: ["", `${formatToLocaleString(payout)} ${valueType}`],
      marker: { color: stbColors.charts.brand },
      name: advicePlot.withInsurance[lang],
    },
  ];
};
